import axios from 'axios';

export const getProgressReport = async (params) => {
  try {
    const response = await axios.get(`${process.env.VUE_APP_API_URL}/api/progress-report`, {
      params: params
    });
    console.log("api", response);
    console.log("api type:", typeof response);
    console.log("api isArray:", Array.isArray(response));
    // Interceptor đã trả về response.data rồi, nên response ở đây đã là data array
    return response;
  } catch (error) {
    console.error('Lỗi khi gọi API báo cáo tiến độ:', error);
    throw error;
  }
};

// Export hàm fetch cụ thể cho component
export const fetchProgressReportData = async (startDate, endDate, schoolName,  provinceId, page = 1, pageSize = 10, product) => {
  const params = {
    startDate: startDate || '',
    endDate: endDate || '',
    page: page,  // Frontend sử dụng 1-based page
    pageSize: pageSize,
    product: product || ''
  };
  
  if (provinceId != null && provinceId !== '') {
    params.provinceId = provinceId;
  }

  if (schoolName != null && schoolName !== '') {
    params.schoolName = schoolName;
  }

  try {
    const result = await getProgressReport(params);
    console.log("fetchProgressReportData result:", result);
    return result;
  } catch (error) {
    console.error('Lỗi trong fetchProgressReportData:', error);
    throw error;
  }
};

export const exportProgressReportExcel = async (startDate, endDate, schoolName,  provinceId, page = 1, pageSize = 10, product) => {
  const params = {
    startDate: startDate || '',
    endDate: endDate || '',
    page: page,
    pageSize: pageSize,
    product: product || ''
  };

  if (provinceId != null && provinceId !== '') {
    params.provinceId = provinceId;
  }

  if (schoolName != null && schoolName !== '') {
    params.schoolName = schoolName;
  }

  try {
    const response = await axios({
      url: `${process.env.VUE_APP_API_URL}/api/progress-report/export-excel`,
      method: 'GET',
      params: params,
      responseType: 'blob'
    });
    return response;
  } catch (error) {
    console.error('Lỗi khi xuất Excel báo cáo tiến độ:', error);
    throw error;
  }
};

export default {
  getProgressReport,
  fetchProgressReportData,
  exportProgressReportExcel
};